import { render } from "./StakeOptimizer.vue?vue&type=template&id=6b833486"
import script from "./StakeOptimizer.vue?vue&type=script&lang=js"
export * from "./StakeOptimizer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakeOptimizer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b833486"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b833486', __exports__)) {
    api.reload('6b833486', __exports__)
  }
  
  module.hot.accept("./StakeOptimizer.vue?vue&type=template&id=6b833486", () => {
    api.rerender('6b833486', render)
  })

}


export default __exports__